/* eslint-disable */
import * as Types from "./types";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type GqlFormVersionFieldsFragment = {
  __typename: "FormVersion";
  uri: string;
  values: {
    __typename: "FormVersionValues";
    uri: string;
    formUri: string;
    snapshotHash?: string | null;
    status?: Types.GqlFormVersionStatus | null;
    operationId: string;
    createdAt: string;
    updatedAt: string;
    versionKind?: Types.GqlFormVersionKind | null;
    publishedAt?: string | null;
    publishNote?: string | null;
    updatedBy?: {
      __typename: "User";
      uri: string;
      email: string;
      firstName: string;
      lastName: string;
    } | null;
    publishedBy?: {
      __typename: "User";
      uri: string;
      email: string;
      firstName: string;
      lastName: string;
      initials?: string | null;
      picture?: string | null;
      latestLoginAt?: string | null;
    } | null;
  };
};

export const FormVersionFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "formVersionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormVersion" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uri" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "values" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uri" } },
                { kind: "Field", name: { kind: "Name", value: "formUri" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "snapshotHash" },
                },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "operationId" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "updatedBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "uri" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "versionKind" } },
                { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "publishedBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "uri" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "initials" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "picture" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "latestLoginAt" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "publishNote" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GqlFormVersionFieldsFragment, unknown>;
